<template>
  <div class="refund-photos-preview" v-if="hasPhotos">
    <!-- Removed Photos -->
    <div v-if="removedPhotos.length > 0" class="photos-section photos-remove">
      <div class="photos-header">
        <CIcon name="cil-trash" size="sm" class="mr-1"/>
        <translate translate-context="accounting.refund">Photos to remove</translate>
        <CBadge color="danger" class="ml-2">{{ removedPhotos.length }}</CBadge>
        <CButton
          color="link"
          size="sm"
          class="ml-auto p-0"
          @click="$emit('clear-removed')"
        >
          <CIcon name="cil-x" size="sm"/>
        </CButton>
      </div>
      <div class="photos-thumbnails">
        <div
          v-for="photo in displayedRemovedPhotos"
          :key="photo.id"
          class="photo-thumb"
          @click="$emit('zoom', photo)"
        >
          <img :src="photo.thumb || photo.thumbnail" :alt="photo.id"/>
        </div>
        <div v-if="removedPhotos.length > maxDisplay" class="photo-more">
          +{{ removedPhotos.length - maxDisplay }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RefundPhotosPreview',
  props: {
    removedPhotos: {
      type: Array,
      default: () => []
    },
    maxDisplay: {
      type: Number,
      default: 6
    }
  },
  computed: {
    hasPhotos() {
      return this.removedPhotos.length > 0
    },

    displayedRemovedPhotos() {
      return this.removedPhotos.slice(0, this.maxDisplay)
    }
  }
}
</script>

<style scoped>
.refund-photos-preview {
  margin-bottom: 1rem;
}

.photos-section {
  border-radius: 6px;
  padding: 0.75rem;
  margin-bottom: 0.5rem;
}

.photos-remove {
  background: #fef2f2;
  border: 1px solid #fca5a5;
}

.photos-header {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
}

.photos-remove .photos-header {
  color: #991b1b;
}

.photos-thumbnails {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.photo-thumb {
  width: 48px;
  height: 48px;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid transparent;
  transition: all 0.2s;
}

.photo-thumb:hover {
  transform: scale(1.05);
  border-color: #3b82f6;
}

.photo-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.photo-more {
  width: 48px;
  height: 48px;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
  font-weight: 500;
  color: #6b7280;
}
</style>
